import React from 'react';

import { ADDRESS_TYPES, ESTABLISHMENT_TYPES } from '../../BusinessSearchField.constants';

export const CONTENT_BY_TYPE = {
  [ESTABLISHMENT_TYPES]: (
    <>
      Try adding a city, state, or zip code or <span>enter your address.</span>
    </>
  ),
  [ADDRESS_TYPES]: (
    <>
      Try adding a city, state, or zip code or <span>enter your business name.</span>
    </>
  ),
};
